export const uk = {
    'show-banners': 'Показать'
};
